import type { LogsInitConfiguration, RumInitConfiguration } from '@prenuvo/nimbus-logger';

export interface LoggerAppConfig {
  DD_SERVICE_NAME: string;
  DD_APP_ID: string;
  DD_TOKEN: string;
}

export interface Logger {
  ok(message: string, messageContext?: object, error?: Error): void;
  debug(message: string, messageContext?: object, error?: Error): void;
  info(message: string, messageContext?: object, error?: Error): void;
  notice(message: string, messageContext?: object, error?: Error): void;
  warn(message: string, messageContext?: object, error?: Error): void;
  error(message: string, messageContext?: object, error?: Error): void;
  critical(message: string, messageContext?: object, error?: Error): void;
  alert(message: string, messageContext?: object, error?: Error): void;
  emerg(message: string, messageContext?: object, error?: Error): void;
}

export const logConfig: Partial<LogsInitConfiguration> = {
  forwardConsoleLogs: 'all',
  forwardErrorsToLogs: true,
};

export const rumConfig: Partial<RumInitConfiguration> = {
  trackSessionAcrossSubdomains: false,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
  site: 'datadoghq.com',
};
